import { Stack, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import ChipBase from '@/components/ui/Chip/Chip';

const MOBILE_WRAPPER_PADDING_X = 2.5;
const DESKTOP_WRAPPER_PADDING_X = 6;

export const Wrapper = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  borderRadius: 15,
  padding: theme.spacing(6, MOBILE_WRAPPER_PADDING_X),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(6, DESKTOP_WRAPPER_PADDING_X),
  },
  margin: theme.spacing(5, 0),
  overflow: 'hidden',
  position: 'relative',

  '&:before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: theme.spacing(MOBILE_WRAPPER_PADDING_X),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(DESKTOP_WRAPPER_PADDING_X),
    },
    zIndex: 1,
    backgroundImage: `linear-gradient(to right,  ${theme.palette.primary.light} 0%, rgba(255, 255, 255, 0) 100%)`,
  },

  '&:after': {
    content: '""',
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: theme.spacing(MOBILE_WRAPPER_PADDING_X),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(DESKTOP_WRAPPER_PADDING_X),
    },
    backgroundImage: `linear-gradient(to left,  ${theme.palette.primary.light} 0%, rgba(255, 255, 255, 0) 100%)`,
  },
}));

export const Chip = styled(ChipBase)(({ theme }) => ({
  alignSelf: 'flex-start',
  marginBottom: theme.spacing(2.5),
  color: theme.palette.primary.dark,
  background: alpha(theme.palette.primary.main, 0.12),
}));

export const Headline = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
}));

export const Subline = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1Redesign,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
}));

export const SliderWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  marginTop: theme.spacing(2),

  '& .slick-track': {
    display: 'flex !important',
    flex: 1,
  },

  '& .slick-slide > div': {
    userSelect: 'text !important',
    margin: `0 ${theme.spacing(MOBILE_WRAPPER_PADDING_X)}`,
    [theme.breakpoints.up('sm')]: {
      margin: `0 ${theme.spacing(DESKTOP_WRAPPER_PADDING_X)}`,
    },
    [theme.breakpoints.up('md')]: {
      margin: `0 ${theme.spacing(2.5)} 0 0`,
    },
  },

  '& .slick-list': {
    display: 'flex !important',
    overflow: 'visible',
    margin: `0 -${theme.spacing(MOBILE_WRAPPER_PADDING_X)}`,
    [theme.breakpoints.up('sm')]: {
      margin: `0 -${theme.spacing(DESKTOP_WRAPPER_PADDING_X)}`,
    },
    [theme.breakpoints.up('md')]: {
      margin: `0 -${theme.spacing(2.5)} 0 0`,
    },
  },
}));
